module.exports = __webpack_public_path__ + "img/bull.777e60db.svg";